const thousandSeparator = (number) => {
  const n = Number(number || 0)

  const x = Math.round(Math.abs(n) * 100) / 100

  const string =
    String(x | 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${string}${n >= 0 ? "" : "-"}`
}

export default thousandSeparator